import React from 'react';

const ImageCategorizationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill={props.color || '#FF8FB1'}
    />
    <path opacity="0.5" d="M30.83 13.75V26.25L9.16998 13.75L20 7.5L30.83 13.75Z" fill="white" />
    <path opacity="0.5" d="M30.83 13.75V26.25L9.16998 13.75L20 7.5L30.83 13.75Z" fill="white" />
    <path opacity="0.5" d="M30.83 26.25L20 32.5L9.16998 26.25L20 20L30.83 26.25Z" fill="white" />
    <path opacity="0.5" d="M30.83 26.25L20 32.5L9.16998 26.25L20 20L30.83 26.25Z" fill="white" />
    <path opacity="0.9" d="M30.83 26.25L20 32.5L9.16998 26.25L20 20L30.83 26.25Z" fill="white" />
    <path opacity="0.5" d="M9.16998 13.75V26.25L20 20L9.16998 13.75Z" fill="white" />
  </svg>
);

export default ImageCategorizationIcon;
